import { ID, Namespaces } from './constants'

export const getIcon = (ns: Namespaces) => `${ID}-icon-${ns}`
